import { Blac, Cubit } from "blac-next";
import WebSocketBloc, {
  AddWebSocketObserverResponse,
  WebsocketMessageType
} from "src/state/WebSocketBloc/WebSocketBloc";
import { serverEventLabResultListenerConstant as constants } from "./serverEventLabResultListener.constant";
import { ServerEventListenerActivator } from "./ServerEventListenerActivator";
import { LifeLineSavedMessage } from "./LifeLineSavedMessage";
import { NavigateFunction } from "react-router-dom";

const { messageHandler } = constants;

export class ServerEventLabResultListenerCubit
  extends Cubit<null>
  implements ServerEventListenerActivator
{
  private registerCounter: number = 0;

  private observer?: AddWebSocketObserverResponse;

  activate(navigate: NavigateFunction) {
    this.observer ??= Blac.getBloc(WebSocketBloc).addObserver(
      WebsocketMessageType.lifeLineItemSaved,
      (message) =>
        void messageHandler({
          navigate,
          message: message as LifeLineSavedMessage
        })
    );

    ++this.registerCounter;
  }

  deactivate() {
    this.registerCounter = Math.max(0, --this.registerCounter);
    if (!this.registerCounter) {
      this.observer?.remove();
      this.observer = undefined;
    }
  }
}
